import React from "react";
import { connect } from "react-redux";
import { isValid } from "redux-form";
import classnames from "classnames";
import { FormattedMessage } from "react-intl";

import MyDeliveryActions from "./actions";
import StepOne from "./steps/stepOne";
import StepTwo from "./steps/stepTwo";
import StepThree from "./steps/stepThree";
import StepFour from "./steps/stepFour";
import StepFive from "./steps/stepFive";
import StepSix from "./steps/stepSix";

import "./style.scss";

const steps = [
  "DELIVERY",
  "DELIVERIES_FUST_HEADER",
  "DELIVERIES_TRANSPORT",
  "DELIVERIES_EXTRA_COST",
  "DELIVERIES_COMMENTS",
  "DELIVERIES_CHECK"
];

interface IProps {
  isFormValid: boolean;
  initFustLines: () => void;
}

interface IState {
  currentStep: number;
}

class Deliveries extends React.Component<IProps, IState> {
  constructor(props) {
    super(props);

    this.state = {
      currentStep: 1
    };
  }

  private goNext = () => {
    this.setState(prevState => ({
      currentStep: prevState.currentStep + 1
    }));
  };

  private goBack = () => {
    this.setState(prevState => ({
      currentStep: prevState.currentStep - 1
    }));
  };

  private renderComponent() {
    switch (this.state.currentStep) {
      case 1: {
        return <StepOne goNext={this.goNext} />;
      }
      case 2: {
        return <StepTwo goNext={this.goNext} goBack={this.goBack} />;
      }
      case 3: {
        return <StepThree goNext={this.goNext} goBack={this.goBack} />;
      }
      case 4: {
        return <StepFour goNext={this.goNext} goBack={this.goBack} />;
      }
      case 5: {
        return <StepFive goNext={this.goNext} goBack={this.goBack} />;
      }
      case 6: {
        return <StepSix goBack={this.goBack} />;
      }
      default: {
        return <StepOne goNext={this.goNext} />;
      }
    }
  }

  private skipStep(step) {
    if (step === 2) {
      this.props.initFustLines();
    }
    this.setState({
      currentStep: step
    });
  }

  public render() {
    const { currentStep } = this.state;
    const { isFormValid } = this.props;
    // @ts-ignore
    if (history.pushState) {
      window.history.pushState(null, "", "#" + currentStep);
    } else {
      window.location.hash = "#" + currentStep;
    }

    return (
      <div id="create-deliveries">
        <div className="header">
          <FormattedMessage id="DELIVERIES_CREATE" tagName="h1" />
          <div className="step-number">
            <FormattedMessage id="DELIVERIES_STEPS" values={{ currentStep }} />
          </div>
        </div>
        <div className="step-line">
          {steps.map((item, index) => (
            <div
              className={classnames(
                "each-step",
                index + 1 === currentStep
                  ? "current"
                  : index + 1 < currentStep
                    ? "past"
                    : "",
                { disabled: !isFormValid }
              )}
              key={index}
              onClick={() => this.skipStep(index + 1)}
            >
              <span className="step-name">
                <FormattedMessage id={item} />
              </span>
              <span className="circle" />
            </div>
          ))}
        </div>
        <div className="content">{this.renderComponent()}</div>
      </div>
    );
  }
}

export default connect(
  state => ({
    isFormValid: isValid("delivery")(state)
  }),
  {
    initFustLines: MyDeliveryActions.initFustLines
  }
)(Deliveries);
